import { AbstractBuilder } from "./AbstractBuilder.js";

export { TimeDimension }

class TimeDimension extends AbstractBuilder {

    static getFilterParams(harmonizedFilters) {
        const params = {};

        for (let key in harmonizedFilters) {
            const filters = [];
            for (let i = 0; i < harmonizedFilters[key].length; ++i) {
                const values = harmonizedFilters[key][i];
                switch (values[0]) {
                    case "bt":
                        filters.push(this.bt(values[1], values[2]));
                        break;
                    case "eq":
                    case "like":
                        filters.eq(this.bt(values[1]));
                        break;
                    case "gt":
                    case "gteq":
                        filters.ge(this.bt(values[1]));
                        break;
                    case "lt":
                    case "lteq":
                        filters.le(this.bt(values[1]));
                        break;
                    case "null":
                        break;
                }
            }

            const filter = this.or(filters).trim();
            if (filter.length) params[key] = filter;
        }

        return params;
    }

    static bt(begin, end) {
        return `${begin}/${end}`;
    }

    static eq(value) {
        return value
    }

    static ge(value) {
        return `${value}/9999-12-31T23:59:59.999Z`;
    }

    static le(value) {
        return `0001-01-01T00:00:00.0Z/${value}`;
    }

    static or(filters) {
        return filters.join(", ");
    }
    
}